import React, { useState, useMemo } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { sportTypeIds } from '../../../utils/eventConstants';
import { ClubCard, LoadingCard, CtaCard } from '../../../components/cards';
import { getClubsVisibleToUser } from '../../../utils/clubs';
import { CtaData } from '../../../components/cards/CtaCard';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';

const Clubs = ({ clubs = [], auth, history, search, clubEvents }) => {
const showTennisContent = auth?.feedPreferences?.showTennisContent;
const showPickleballContent = auth?.feedPreferences?.showPickleballContent;

    const [showAll, setShowAll] = useState();
    const visibleClubs = getClubsVisibleToUser(clubs);

    const tennisClubs = [];
    const pickleballClubs = [];
    visibleClubs.forEach(club => {
        clubEvents.forEach((event) => {
            if (event.clubId === club.id) {
                if (event.sportTypeId === sportTypeIds.TENNIS && !tennisClubs.includes(club)) {
                    tennisClubs.push(club);
                }
                if (event.sportTypeId === sportTypeIds.PICKLEBALL && !pickleballClubs.includes(club)) {
                    pickleballClubs.push(club);
                }
                if (tennisClubs.includes(club) && pickleballClubs.includes(club)) {
                    return false;
                }
            }
        });
    });

    const showPickleball = !!showPickleballContent;
    const showTennis = !!showTennisContent;

    const filterClubs = () => {
        if (showTennis && showPickleball) {
            return [...new Set([...tennisClubs, ...pickleballClubs])];
        }
        if (showTennis) {
            return tennisClubs;
        }
        if (showPickleball) {
            return pickleballClubs;
        }
        return tennisClubs;
    };
    const filteredClubs = useMemo(filterClubs, [showTennis, showPickleball, tennisClubs, pickleballClubs]);

    return (
        <>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={'My clubs, teams and groups'} data-testid="dashboard.clubs.section-heading" />
                        {clubs && clubs?.length > 4 && (
                            <div className={`link clickable`} onClick={() => setShowAll(!showAll)} data-testid="dashboard.clubs.view-toggle">
                                {showAll ? 'View Less' : 'View All'}
                            </div>
                        )}
                    </SectionHeadingWrapper>
                </div>
            </div>
            {filteredClubs ? (
                <div className="row">
                    {filteredClubs.length > 0 && (
                        <>
                            {filteredClubs.map((club, i) => {
                                if (i <= 1 || (i > 1 && showAll)) {
                                    return (
                                        <div
                                            className={`col-12 col-md-4`}
                                            key={`club-${club.id}`}
                                        >
                                            <ClubCard
                                                club={club}
                                                force={{
                                                    cardView: true,
                                                    featured: true,
                                                }}
                                                data-testid={`dashboard.clubs.item-${club.id}`}
                                            />
                                        </div>
                                    );
                                }
                                return <div />;
                            })}
                        </>
                    )}
                    {(auth.user?.isPlayer) && (
                        <div className={`col-12 col-md-4`}>
                            <CtaCard
                                data={CtaData.CREATE_PERSONAL_CLUB}
                                onCtaClick={() => {
                                    history.push('/create-players-group');
                                }}
                                className="club-card club-card-featured"
                                force={{ iconCard: true }}
                                data-testid="dashboard.clubs.cta-create-group"
                            />
                        </div>
                    )}
                    {auth.user?.isPlayer && (
                        <div className={`col-12 col-md-4`}>
                            <CtaCard
                                data={CtaData.FIND_JOIN_CLUB}
                                onCtaClick={() => {
                                    let url = `/search?type=clubs&startDate=${moment(new Date()).format('MM/DD/YYYY')}`;
                                    if (search.geocoded) {
                                        url = `/search?type=clubs&startDate=${moment(new Date()).format('MM/DD/YYYY')}&distance=100mi&lat=${search.geocoded.lat}&lng=${search.geocoded.lng}&location=${search.geocoded.location}&locationInputValue=${search.geocoded.location}`;
                                    }
                                    history.push(url);
                                }}
                                className="club-card club-card-featured"
                                force={{ iconCard: true }}
                                data-testid="dashboard.clubs.cta-find-club"
                            />
                        </div>
                    )}
                </div>
            ) : (
                <div className="row">
                    <div className={`col-12 col-md-4`}>
                        <LoadingCard data-testid="dashboard.clubs.loading-card" />
                    </div>
                </div>
            )}
        </>
    );
};

Clubs.propTypes = {
    clubs: PropTypes.instanceOf(Array),
    auth: PropTypes.instanceOf(Object).isRequired,
    history: PropTypes.instanceOf(Object).isRequired,
    search: PropTypes.instanceOf(Object).isRequired,
    clubEvents: PropTypes.instanceOf(Array),
};
Clubs.defaultProps = {
    clubs: [],
    clubEvents: [],
};

export default Clubs;
